import * as DEVICES from 'constants/deviceTypes';

export function getDeviceContext() {
  const android = typeof AndroidInterface !== 'undefined' ? DEVICES.ANDROID : null;
  const ios =
    typeof webkit !== 'undefined' && window.webkit.messageHandlers.webAppLoaded
      ? DEVICES.IOS
      : null;
  const device = android || ios;

  return {
    device: device || DEVICES.DESKTOP,
    isNative: device ? true : false
  };
}
